<template>
    <div class="phone-screen__wrapper ">
        <div class="phone-screen phone-screen-custom">
        <div class="phone-screen__inner">
            <div class="phone-screen__border phone-screen-custom__border"><img src="@/assets/images/phone.png" alt="phone-border"></div>
            <div class="phone-screen__main">
                <h1 class="phone-screen__title">Grace due</h1>
                <div class="block full_hight">
                    <div class="card flex flex__column flex_between">
                        <Overdue_payment :emi="false" :progress="false" :grace="true"/>
                        <Overdue_payment :emi="false" :progress="false" :grace="true"/>
                        <nextDisplayBtns btn_first="Pay grace" :is_btn_second="false"/>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import Overdue_payment from '../widgets/homescreen/overduePayment.vue'
import nextDisplayBtns from '../widgets/homescreen/nextDisplayBtns.vue'

export default {
    components:{
        Overdue_payment,
        nextDisplayBtns,
    },
    data(){
        return{
            showPopup: false
        }
    },

}
</script>